import { createSelector } from 'reselect';

export const paymentMethodsSelector = state => state.payment;

export const paymentMethodCreditCardSelector = state => {
    const { paymentMethods } = state.payment;
    return paymentMethods.find(paymentMethod => paymentMethod.name === 'Credit Card') || {};
};

export const creditCardBrandsSelector = createSelector(paymentMethodCreditCardSelector, state => state.brands);

export const pubKeySelector = createSelector(paymentMethodsSelector, state => state.card.pubKey);
export const sepaPubKeySelector = createSelector(paymentMethodsSelector, state => state.sepa.pubKey);
export const sepaClientSecretSelector = createSelector(paymentMethodsSelector, state => state.sepa.clientSecret);
export const sepaPaymentSuccessSelector = createSelector(paymentMethodsSelector, state => state.sepa.paymentSuccess);
